import { render, staticRenderFns } from "./Top2.vue?vue&type=template&id=7aa663c9&scoped=true&"
import script from "./Top2.vue?vue&type=script&lang=js&"
export * from "./Top2.vue?vue&type=script&lang=js&"
import style0 from "./Top2.vue?vue&type=style&index=0&id=7aa663c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa663c9",
  null
  
)

export default component.exports